import { Component } from '@angular/core';
import { ModalController, NavParams } from '@ionic/angular';

interface AlertButton {
  text: string;
  fill: string;
  color: string;
  action: string;
}

interface AlertInput {
  type: string;
  icon: string;
  value: any;
  placeholder: string;
  maxLength: string;
}

@Component({
  selector: 'app-login-alert',
  templateUrl: './custom-alert.component.html',
  styleUrls: ['./custom-alert.component.scss'],
})
export class CustomAlertComponent {

  icon: string; // danger, success
  title: string;
  subtitle: string;
  message: string;
  buttons: Array<AlertButton>;
  input: AlertInput;
  iconsPath = '/assets/imgs/icons/';

  constructor(
    private modalController: ModalController,
    private navParams: NavParams,
  ) {
    this.icon = this.navParams.get('icon');
    this.title = this.navParams.get('title');
    this.subtitle = this.navParams.get('subtitle');
    this.message = this.navParams.get('message');
    this.buttons = this.navParams.get('buttons');
    this.input = this.navParams.get('input');
  }

  closeAlert(action = ''): void {
    const data = {
      action,
      input: this.input ? this.input.value : null
    };
    // se cierra el modal de alerta no pasa nada
    this.modalController.dismiss(data);
  }

}
